module.exports = __webpack_public_path__ + "media/images/es_419/altruism-segment-6ae8fedff2d7ca5dfc5dd31ac5a23a34.jpg";